import { render, staticRenderFns } from "./ExtendedForecast.vue?vue&type=template&id=012db8a8&scoped=true"
import script from "./ExtendedForecast.vue?vue&type=script&lang=js"
export * from "./ExtendedForecast.vue?vue&type=script&lang=js"
import style0 from "./ExtendedForecast.vue?vue&type=style&index=0&id=012db8a8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.6.11_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012db8a8",
  null
  
)

export default component.exports